import { ActivityEntityName, EntityFlag } from '@jms/model';
import type { EntityManifestCard } from '@workbuddy/services/entities/entity.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

// Flag entity manifest. Card-only: Flags are created and resolved through the section-relation
// dialogs (section.relation/), never opened as a page, so there are no operations or surfaces here.
const card: EntityManifestCard<EntityFlag> = {
  component: () => import('./presentation/card.flag').then(module => module.CardFlagComponent),
  resolution: 'snapshot',
  summarize: flag => ({ title: flag.category?.name ?? 'Flag', line1: flag.message, line2: flag.status }),
};

export const flagManifest = registerManifest<EntityFlag>({ entity: ActivityEntityName.Flag, presentation: { card } });
